<!-- 水泵设置 -->
<template>
    <div class='container containerBox'>
        <el-form ref="form" :model="form" inline label-width="80px">
            <el-form-item label="电费单价">
                <el-input v-model="form.price"></el-input>
            </el-form-item>
            <el-form-item label="分成比例">
                <el-input v-model="form.percent"></el-input>
            </el-form-item>
           <div class="list-box">
                <el-row :gutter="20" class="item header-item">
                    <el-col :span="8">
                        <div>
                        水泵名称/addr
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div>
                        改造前功率(KW/h)
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div>
                        改造后功率(KW/h)
                        </div>
                    </el-col>
                </el-row>
                <template v-for="(v, i) in deviceList">
                    <el-row :gutter="20" class="item" :key="i">
                        <el-col :span="8">
                            <div>
                            {{v.name}} / {{v.node_var[0].var_addr}}
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div>
                                <el-input v-model="v.power_before" placeholder="请输入改造前功率"></el-input>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div>
                                <el-input v-model="v.power_after"  placeholder="请输入改造后功率"></el-input>
                            </div>
                        </el-col>
                    </el-row>
                </template>
                
           </div>
            <el-form-item>
                <el-button type="primary" @click="handleSave">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Service from '@/api/Service'

export default {
    name:  'pumpsetting',
    data() {
        return {
            deviceList: [],
            form: {
                price: '',
                percent: '',
            },
        };
    },

    components: {},

    created() {
        this.getData();
    },

    methods: {
        getData: async function() {
            // 获取机房监控
            let res = await Service.getServerroombypid();
            if(res !== 'success') {
                if(res[0].map_value_phone === '') {
                    this.$message({
                        message: '未配置移动端机房组态！',
                        type: 'warning',
                        duration: 3000,
                        onClose: ()=>{
                            
                        }
                    });
                }else{
                    let arr = JSON.parse(res[0].map_value_phone)
                    
                    this.deviceList = arr.filter(v=>{
                        return v.deviceType === 'LQB' || v.deviceType === 'LDB'
                    });
                }
                
            }
        },
        handleSave() {
            if(this.form.price === '' || this.form.percent === '') {

                return
            }
        },
    }
}

</script>
<style lang='less' scoped>
    .list-box{
        margin: 0 20px 20px;
    }
    .header-item{
        background-color: #fafafa;
    }
    .item{
        height: 60px;
        text-align: center;
        line-height: 40px;
        box-sizing: border-box;
        border-bottom: 1px solid #eee;
        padding: 10px 0;
    }
</style>